module.exports = __webpack_public_path__ + "img/organizationpix.f90909f5.png";